import { render, staticRenderFns } from "./ReceiveItems.vue?vue&type=template&id=ff2f7f0e&"
import script from "./ReceiveItems.vue?vue&type=script&lang=js&"
export * from "./ReceiveItems.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveItems.vue?vue&type=style&index=0&id=ff2f7f0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports